export default __webpack_public_path__ + "static/media/email.7cc8c68c.svg";